import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "faq-page" };
const _hoisted_2 = { class: "faq-container" };
const _hoisted_3 = { class: "item-info" };
const _hoisted_4 = { class: "item-name" };
const _hoisted_5 = { class: "faq-items-section" };
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "section-header" };
const _hoisted_8 = { class: "header-actions-group" };
const _hoisted_9 = {
    key: 0,
    class: "json-editor-section"
};
const _hoisted_10 = {
    key: 0,
    class: "json-error"
};
const _hoisted_11 = { class: "cell-value" };
const _hoisted_12 = ["title"];
const _hoisted_13 = {
    key: 1,
    class: "empty-state-section"
};
const _hoisted_14 = { class: "form-group" };
import { ref, computed, watch, onMounted } from 'vue';
import { useAdmin } from '@/composables/useAdmin';
import MGDialog from '@/components/elements/MGDialog.vue';
import MGButton from '@/components/elements/MGButton.vue';
import AdminTable from '@/admin/components/AdminTable.vue';
import AdminListSection from '@/admin/components/AdminListSection.vue';
import AdminHeaderActions from '@/admin/components/AdminHeaderActions.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FaqPage',
    setup(__props) {
        const admin = useAdmin();
        const faqItemsTable = ref(null);
        const selectedFaq = ref(null);
        const saving = ref(false);
        const showValidationToast = ref(false);
        const validationMessage = ref('');
        const showAddFaqModal = ref(false);
        const showDeleteFaqDialog = ref(false);
        const showDeleteItemDialog = ref(false);
        const newFaqName = ref('');
        const deleteItemId = ref(null);
        const showJsonEditor = ref(false);
        const jsonEditorContent = ref('');
        const jsonError = ref('');
        const faqItemColumns = ref([
            {
                field: 'question',
                label: 'Question',
                width: '2fr',
                sortable: true,
                editable: true,
                type: 'text',
                required: true,
                placeholder: 'e.g., How do I reset my password?'
            },
            {
                field: 'answer',
                label: 'Answer',
                width: '3fr',
                sortable: false,
                editable: true,
                type: 'textarea',
                required: true,
                placeholder: 'e.g., Click on "Forgot Password" on the login page...'
            }
        ]);
        const faqs = computed(() => admin.adminState.faqs);
        const faqLoading = computed(() => admin.adminState.faqLoading);
        watch(faqs, (newFaqs) => {
            if (selectedFaq.value && newFaqs) {
                selectedFaq.value = newFaqs.find((f) => f.id === selectedFaq.value.id) || null;
            }
        }, { deep: true });
        function truncateText(text, length) {
            if (!text)
                return '—';
            return text.length > length ? text.substring(0, length) + '...' : text;
        }
        function selectFaq(faq) {
            selectedFaq.value = faq;
            showJsonEditor.value = false;
            jsonEditorContent.value = '';
            jsonError.value = '';
        }
        function refreshFaqs() {
            admin.getFaqs();
        }
        function newFaq() {
            showAddFaqModal.value = true;
        }
        function saveFaq() {
            let faqToSave = selectedFaq.value;
            if (showJsonEditor.value) {
                try {
                    faqToSave = JSON.parse(jsonEditorContent.value);
                    jsonError.value = '';
                }
                catch (e) {
                    jsonError.value = 'Invalid JSON: ' + e.message;
                    return;
                }
            }
            if (!faqToSave)
                return;
            saving.value = true;
            admin.updateFaq(faqToSave.id, faqToSave, () => {
                saving.value = false;
                selectedFaq.value = faqToSave;
            });
        }
        function toggleJsonEditor() {
            jsonError.value = '';
            if (showJsonEditor.value) {
                try {
                    const parsed = JSON.parse(jsonEditorContent.value);
                    selectedFaq.value = parsed;
                    showJsonEditor.value = false;
                }
                catch (e) {
                    jsonError.value = 'Invalid JSON: ' + e.message;
                }
            }
            else {
                jsonEditorContent.value = JSON.stringify(selectedFaq.value, null, 2);
                showJsonEditor.value = true;
            }
        }
        function applyJsonToFaq() {
            try {
                const parsed = JSON.parse(jsonEditorContent.value);
                selectedFaq.value = parsed;
                jsonError.value = '';
                return true;
            }
            catch (e) {
                jsonError.value = 'Invalid JSON: ' + e.message;
                return false;
            }
        }
        function addFaq() {
            if (!newFaqName.value.trim()) {
                validationMessage.value = 'Please enter a FAQ name';
                showValidationToast.value = true;
                return;
            }
            admin.createFaq({ faqName: newFaqName.value }, (result) => {
                admin.adminState.faqs.push(result);
                selectFaq(result);
                showAddFaqModal.value = false;
                newFaqName.value = '';
            });
        }
        function confirmDeleteFaq() {
            admin.deleteFaq(selectedFaq.value.id, () => {
                admin.adminState.faqs = admin.adminState.faqs.filter((f) => f.id !== selectedFaq.value.id);
                selectedFaq.value = admin.adminState.faqs.length > 0 ? admin.adminState.faqs[0] : null;
            });
            showDeleteFaqDialog.value = false;
        }
        function handleItemEditSave({ rowId, data }) {
            if (!data.question || !data.answer) {
                const missing = [];
                if (!data.question)
                    missing.push('Question');
                if (!data.answer)
                    missing.push('Answer');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            const items = selectedFaq.value.faqItems || [];
            const index = items.findIndex((item) => item.id === rowId);
            if (index !== -1) {
                items[index] = { ...items[index], question: data.question, answer: data.answer };
                admin.updateFaq(selectedFaq.value.id, selectedFaq.value);
            }
        }
        function handleItemDelete(row) {
            deleteItemId.value = row.id;
            showDeleteItemDialog.value = true;
        }
        function confirmDeleteItem() {
            selectedFaq.value.faqItems = (selectedFaq.value.faqItems || []).filter((item) => item.id !== deleteItemId.value);
            admin.updateFaq(selectedFaq.value.id, selectedFaq.value);
            showDeleteItemDialog.value = false;
            deleteItemId.value = null;
        }
        function handleItemAdd(data) {
            if (!data.question || !data.answer) {
                const missing = [];
                if (!data.question)
                    missing.push('Question');
                if (!data.answer)
                    missing.push('Answer');
                validationMessage.value = `Please fill in: ${missing.join(' and ')}`;
                showValidationToast.value = true;
                return;
            }
            if (!selectedFaq.value.faqItems) {
                selectedFaq.value.faqItems = [];
            }
            selectedFaq.value.faqItems.push({
                question: data.question,
                answer: data.answer,
                faqId: selectedFaq.value.id
            });
            admin.updateFaq(selectedFaq.value.id, selectedFaq.value, () => {
                faqItemsTable.value?.resetAddRow();
            });
        }
        onMounted(() => {
            admin.getFaqs();
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_snackbar = _resolveComponent("v-snackbar");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(AdminListSection, {
                            title: "FAQs",
                            items: faqs.value,
                            "selected-id": selectedFaq.value?.id,
                            loading: faqLoading.value,
                            "empty-message": "No FAQs yet",
                            "search-fields": ['faqName'],
                            "show-new-button": false,
                            "new-button-text": "New FAQ",
                            onSelect: selectFaq,
                            onRefresh: refreshFaqs,
                            onNew: newFaq
                        }, {
                            item: _withCtx(({ item }) => [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.faqName), 1)
                                ])
                            ]),
                            _: 1
                        }, 8, ["items", "selected-id", "loading"]),
                        _createElementVNode("div", _hoisted_5, [
                            (selectedFaq.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("h2", null, _toDisplayString(selectedFaq.value.faqName), 1),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createElementVNode("button", {
                                                class: "action-btn secondary",
                                                onClick: toggleJsonEditor
                                            }, _toDisplayString(showJsonEditor.value ? 'Form View' : 'JSON View'), 1),
                                            _createVNode(AdminHeaderActions, {
                                                loading: saving.value,
                                                "has-id": !!selectedFaq.value.id,
                                                onSave: saveFaq,
                                                onDelete: _cache[0] || (_cache[0] = ($event) => (showDeleteFaqDialog.value = true)),
                                                onNew: newFaq
                                            }, null, 8, ["loading", "has-id"])
                                        ])
                                    ]),
                                    (showJsonEditor.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((jsonEditorContent).value = $event)),
                                                class: "json-editor-textarea",
                                                spellcheck: "false"
                                            }, null, 512), [
                                                [_vModelText, jsonEditorContent.value]
                                            ]),
                                            (jsonError.value)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(jsonError.value), 1))
                                                : _createCommentVNode("", true)
                                        ]))
                                        : (_openBlock(), _createBlock(AdminTable, {
                                            key: 1,
                                            ref_key: "faqItemsTable",
                                            ref: faqItemsTable,
                                            title: "Questions & Answers",
                                            icon: "❓",
                                            columns: faqItemColumns.value,
                                            data: selectedFaq.value.faqItems || [],
                                            loading: faqLoading.value,
                                            searchable: true,
                                            "search-placeholder": "Search questions...",
                                            collapsible: false,
                                            "default-expanded": true,
                                            editable: true,
                                            selectable: false,
                                            deletable: true,
                                            addable: true,
                                            "empty-message": "No questions yet. Add one below.",
                                            onRowEditSave: handleItemEditSave,
                                            onRowDelete: handleItemDelete,
                                            onRowAdd: handleItemAdd
                                        }, {
                                            "cell-question": _withCtx(({ row }) => [
                                                _createElementVNode("span", _hoisted_11, _toDisplayString(row.question), 1)
                                            ]),
                                            "cell-answer": _withCtx(({ row }) => [
                                                _createElementVNode("span", {
                                                    class: "cell-value",
                                                    title: row.answer || ''
                                                }, _toDisplayString(truncateText(row.answer || '', 100)), 9, _hoisted_12)
                                            ]),
                                            _: 1
                                        }, 8, ["columns", "data", "loading"]))
                                ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_13, _cache[11] || (_cache[11] = [
                                    _createElementVNode("p", null, "Select an FAQ to view questions", -1)
                                ])))
                        ])
                    ])
                ]),
                _createVNode(MGDialog, {
                    modelValue: showAddFaqModal.value,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((showAddFaqModal).value = $event)),
                    title: "Add FAQ",
                    "max-width": "400px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_14, [
                            _cache[12] || (_cache[12] = _createElementVNode("label", null, "FAQ Name", -1)),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((newFaqName).value = $event)),
                                type: "text",
                                class: "form-input",
                                placeholder: "e.g., Money FAQs"
                            }, null, 512), [
                                [_vModelText, newFaqName.value]
                            ])
                        ])
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Save",
                            onClick: addFaq,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[3] || (_cache[3] = ($event) => (showAddFaqModal.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteFaqDialog.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((showDeleteFaqDialog).value = $event)),
                    title: "Delete FAQ",
                    "max-width": "300px",
                    persistent: true
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "Are you sure you want to delete \"" + _toDisplayString(selectedFaq.value?.faqName) + "\"? This will delete all questions in this FAQ.", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteFaq,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[5] || (_cache[5] = ($event) => (showDeleteFaqDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showDeleteItemDialog.value,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((showDeleteItemDialog).value = $event)),
                    title: "Delete Question",
                    "max-width": "300px",
                    persistent: true
                }, {
                    content: _withCtx(() => _cache[13] || (_cache[13] = [
                        _createElementVNode("p", null, "Are you sure you want to delete this question?", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Delete",
                            onClick: confirmDeleteItem,
                            stacked: true
                        }),
                        _createVNode(MGButton, {
                            text: "Cancel",
                            outline: true,
                            onClick: _cache[7] || (_cache[7] = ($event) => (showDeleteItemDialog.value = false)),
                            stacked: true
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_snackbar, {
                    modelValue: showValidationToast.value,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((showValidationToast).value = $event)),
                    timeout: 4000,
                    location: "bottom",
                    color: "error"
                }, {
                    actions: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                            icon: "mdi-close",
                            size: "small",
                            onClick: _cache[9] || (_cache[9] = ($event) => (showValidationToast.value = false))
                        })
                    ]),
                    default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(validationMessage.value) + " ", 1)
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
